// src/mixins/tour.mixin.js
import { createTour } from '@/domain/tour/shepherdTour.js';

export default {
  data() {
    return { tour: null };
  },
  methods: {
    startTour() {
      const translate = this.$i18n.t.bind(this.$i18n);
      this.tour = createTour(translate);
    },
    resetTutorial() {
      this.userService.updateStep(0).then(() => this.startTour());
    },
  },
};
